export enum AssignmentRoles {
  ESTUDIANTE = 'ESTUDIANTE',
  CORRECTOR = 'CORRECTOR',
}
